import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withViewTransitions } from '@angular/router';
import { DateAdapter, provideCalendar } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { BarChart, HeatmapChart, LineChart, PieChart } from 'echarts/charts';
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  MarkAreaComponent,
  MarkLineComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { provideEchartsCore } from 'ngx-echarts';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { kioskAuthInterceptor } from './core/interceptors/kiosk-auth.interceptor';
import { LocalIpInterceptor } from './core/interceptors/local-ip.interceptor';
import { IpService } from './core/services/IpService';

// Register ECharts components
echarts.use([
  BarChart,
  HeatmapChart,
  LineChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  VisualMapComponent,
  MarkLineComponent,
  MarkAreaComponent,
  DataZoomComponent,
  CanvasRenderer,
]);

// ✅ Declare function before appConfig
export function initIp(ipService: IpService) {
  return () => ipService.loadLocalIp();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withInterceptors([authInterceptor, kioskAuthInterceptor])),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-bottom-left',
      timeOut: 4500,
      closeButton: true,
      progressBar: true,
      progressAnimation: 'decreasing',
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true,
      maxOpened: 5,
    }),
    provideBrowserGlobalErrorListeners(),
    provideNativeDateAdapter(),
    provideEchartsCore({ echarts }),
    provideCalendar({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),

    // Ensure Local IP loads before app bootstrap
    {
      provide: APP_INITIALIZER,
      useFactory: initIp,
      deps: [IpService],
      multi: true,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: LocalIpInterceptor,
      multi: true,
    },

    // Recaptcha site key
    // {
    //   provide: RECAPTCHA_V3_SITE_KEY,
    //   useValue: environment.recaptchaSiteKey
    // }
  ],
};
